import React, { useMemo } from 'react'
import { RecordList } from '../BusinessDetailReport/BusinessDetailReport'
import styles from '../BusinessDetailReport/BusinessDetailReport.module.scss'
import { InlineList } from './PersonalInfo'
import { buildPeople, buildSexOffenses } from './peopleModel'

const plural = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`

export default function People({ person }) {
    const model = useMemo(() => buildPeople(person), [person])
    if (!model.hasData) return <div className={styles.calmLine}>No relatives or associates found.</div>
    return (
        <div className={styles.uccList}>
            <InlineList label={plural(model.relatives.length, 'relative')} items={model.relatives} />
            <InlineList label={plural(model.associates.length, 'associate')} items={model.associates} />
        </div>
    )
}

export function SexOffenses({ person }) {
    const rows = useMemo(() => buildSexOffenses(person), [person])
    if (!rows.length) return <div className={styles.calmLine}>No sex offender registry records found.</div>
    return <div className={styles.uccList}><RecordList items={rows} /></div>
}
